import TableBody from "@mui/material/TableBody";
import React from "react";
import {
  DragDropContext,
  DropResult,
  Droppable,
  ResponderProvided,
} from "react-beautiful-dnd";

const DroppableTable =
  (onDragEnd: (result: DropResult, provided: ResponderProvided) => void) =>
  ({ children }: { children: React.ReactNode }) => (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="1" direction="vertical">
        {(provided) => (
          <TableBody {...provided.droppableProps} ref={provided.innerRef}>
            {children}
            {provided.placeholder}
          </TableBody>
        )}
      </Droppable>
    </DragDropContext>
  );

export default DroppableTable;
